export enum UserRole {
  Anonymous = 'Anonymous',
  Customer = 'Customer',
  Prospect = 'Prospect'
}
